import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserStore } from '@app/store/user.store';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard extends KeycloakAuthGuard {
  userStore = inject(UserStore);

  constructor(router: Router, protected readonly keycloak: KeycloakService) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
    }
    return new Promise<boolean | UrlTree>((resolve) => {
      const checkUser = () => {
        const user = this.userStore.user();
        const loadUser = this.userStore.loadUser();

        if (!loadUser) {
          if (user && user.admin) {
            resolve(true);
          } else if (user && user.admin === false) {
            resolve(this.router.parseUrl('/home'));
          } else {
            resolve(this.router.parseUrl('/error'));
          }
        } else {
          setTimeout(checkUser, 100);
        }
      };

      checkUser();
    });
  }
}
